import { useTranslations } from 'next-intl';

import { type DashboardV2PeriodType } from '../../generated/graphql';

export function useFormatOperationPeriod(): (operationPeriod: DashboardV2PeriodType) => string {
  return useTranslations('charts.filters.period.options');
}
